import * as actions from '../constants/actions'
import { createReducer } from '../utils/redux'
import * as pages from '../constants/pages'
import * as layouts from '../constants/layouts'

export default createReducer([], {

    [actions.CHANGE_PAGE]: (state, action) => [action.page],

    [actions.CLOSE_PAGE]: (state, action) => state.slice(1),

    [actions.ADD_OVERLAY_PAGE]: (state, action) => [action.page, ...state],

    [actions.VIEW_STOMPUNKT]: (state, action) => openStompunktOverlayPage(state),

    [actions.CHANGE_LAYOUT]: (state, action) => {
        if (action.layout === layouts.WIDE && state.length === 0) {
            return [pages.FILTER]
        }
        else if (action.layout === layouts.NARROW && state.length === 1) {
            return []
        }
        else {
            return state
        }
    },

    [actions.SELECT_WITH_POLYGON]: (state, action) => [pages.SELECTION],

    [actions.ZOOM_TO_CURRENT_STOMPUNKT]: (state, action, fullState) => fullState.layout === layouts.NARROW ? [] : state

})

function openStompunktOverlayPage(state) {
    if (state[0] === pages.STOMPUNKT) {
        return state
    }
    else {
        return [pages.STOMPUNKT, ...state]
    }
}


// WEBPACK FOOTER //
// ./src/reducers/currentPage.js